<template>
  <div>
    <div v-if="errors.length >= 1">
      {{ errors }}
    </div>
    <card>
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            List of Locations
            <vuetable ref="positions"
                      :fields="columns"
                      :api-mode="false"
                      :data="locations"
            ></vuetable>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import { RosterAPIService } from '../../servicehandlers/RosterHandler';
import loginCheckMixin from '@/mixin';
import Vuetable from 'vuetable-2';

const rosterAPIService = new RosterAPIService();

export default {
  name: 'Positions',
  components: {
    Vuetable
  },
  mixins: [loginCheckMixin],
  data: () => ({
    state: null,
    login: {},
    errors: [],
    locations: [],
    options: {},
    columns: ['id', 'name'],
  }),

  mounted() {
    this.getLocations();
  },

  methods: {
    // manual submit login detected.
    getLocations() {
      rosterAPIService.getLocations(this.$router)
      .then((resp) => {
        this.locations = resp;
      })
      .catch((error) => {
        console.log('Error: ', error);
      });
    },
  },
}
</script>

<style>
input {
  text-align: left;
}
</style>

